function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n"])));
var Title = styled.h3(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0;\n  margin-bottom: 4px;\n  padding: 0;\n  font-size: 12px !important;\n  line-height: 16px !important;\n  color: #333333;\n  font-weight: bold;\n"])));
var SelectWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);
  var _super = _createSuper(Select);
  function Select() {
    var _this;
    _classCallCheck(this, Select);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderOptions", function () {
      return _this.props.options.map(function (option) {
        return {
          value: _this.props.getValue(option),
          label: _this.props.getOptionText(option)
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Title, null, _this.props.title), /*#__PURE__*/React.createElement(SelectWrapper, null, /*#__PURE__*/React.createElement(ReactSelect, {
        isDisabled: _this.props.isLoading,
        value: {
          value: _this.props.selectedValue,
          label: _this.props.getOptionText({
            key: _this.props.selectedValue
          })
        },
        onChange: function onChange(e) {
          _this.props.onValueChange(e.value);
        },
        options: _this.renderOptions(),
        isSearchable: false,
        menuPlacement: "bottom"
      })));
    });
    return _this;
  }
  return _createClass(Select);
}(React.Component);
_defineProperty(Select, "propTypes", {
  title: PropTypes.string,
  selectedValue: PropTypes.string,
  options: PropTypes.array,
  isLoading: PropTypes.bool,
  onValueChange: PropTypes.func,
  getValue: PropTypes.func,
  getOptionText: PropTypes.func,
  getOptionHint: PropTypes.func
});
var SurveyDropdown = /*#__PURE__*/function (_React$Component2) {
  _inherits(SurveyDropdown, _React$Component2);
  var _super2 = _createSuper(SurveyDropdown);
  function SurveyDropdown() {
    var _this2;
    _classCallCheck(this, SurveyDropdown);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "render", function () {
      var answerValue = null;
      if (_this2.props.surveyAnswers[_this2.props.question.key] && _this2.props.surveyAnswers[_this2.props.question.key].answer && _this2.props.surveyAnswers[_this2.props.question.key].answer.value) {
        answerValue = _this2.props.surveyAnswers[_this2.props.question.key].answer.value;
      }
      return /*#__PURE__*/React.createElement(Select, {
        title: '',
        selectedValue: answerValue,
        options: _this2.props.question.values,
        isLoading: false,
        onValueChange: function onValueChange(e) {
          var value = e;
          if (value !== answerValue) {
            _this2.props.onChange(value);
          }
        },
        getValue: function getValue(opt) {
          return opt.key;
        },
        getOptionText: function getOptionText(opt) {
          return _this2.props.getLabel(opt.key);
        },
        getOptionHint: function getOptionHint(opt) {
          return _this2.props.getLabel(opt.key);
        }
      });
    });
    return _this2;
  }
  return _createClass(SurveyDropdown);
}(React.Component);
_defineProperty(SurveyDropdown, "propTypes", {
  question: PropTypes.object,
  surveyAnswers: PropTypes.object,
  getLabel: PropTypes.func,
  onChange: PropTypes.func
});
export default SurveyDropdown;